"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Numbers = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
bignumber_js_1.default.config({ EXPONENTIAL_AT: 1e9 });
class Numbers {
    constructor() { }
    static maxUint256() {
        return new bignumber_js_1.default(2).exponentiatedBy(256).minus(1).toString();
    }
    static add(value1, value2) {
        const BN1 = new bignumber_js_1.default(value1);
        const BN2 = new bignumber_js_1.default(value2);
        return BN1.plus(BN2).toString();
    }
    static sub(value1, value2) {
        const BN1 = new bignumber_js_1.default(value1);
        const BN2 = new bignumber_js_1.default(value2);
        return BN1.minus(BN2).toString();
    }
    static div(value1, value2) {
        const BN1 = new bignumber_js_1.default(value1);
        const BN2 = new bignumber_js_1.default(value2);
        if (BN2.isZero()) {
            throw new Error("can't divide it by zero");
        }
        return BN1.dividedBy(BN2).toString();
    }
    static mul(value1, value2) {
        const BN1 = new bignumber_js_1.default(value1);
        const BN2 = new bignumber_js_1.default(value2);
        return BN1.multipliedBy(BN2).toString();
    }
    static lt(value1, value2) {
        const BN1 = new bignumber_js_1.default(value1);
        const BN2 = new bignumber_js_1.default(value2);
        return BN1.isLessThan(BN2);
    }
    static gt(value1, value2) {
        const BN1 = new bignumber_js_1.default(value1);
        const BN2 = new bignumber_js_1.default(value2);
        return BN1.isGreaterThan(BN2);
    }
    static fromWei(value) {
        return new bignumber_js_1.default(value).dividedBy(Math.pow(10, 18)).toString();
    }
    static toWei(value) {
        return new bignumber_js_1.default(value).multipliedBy(Math.pow(10, 18)).toString();
    }
}
exports.Numbers = Numbers;
